<template>
    <div style="padding: 5px 20px;">


<!--                <span>{{this.title}}</span>-->
                <template v-for="(item,index) in quesList">
                    <div>
                        <template v-if="item.questionType==22">
                            <el-divider></el-divider>
                        </template>
                        <template v-if="item.questionName!=''">
                        <p>
                            <span><b style="color: red">{{item.required==1?'*':''}}</b></span>
                            <template v-if="item.questionClassId!=3&&item.questionClassId!=8">
                            <span>{{index+1}}.</span>
                            </template>
                            <template v-if="item.questionType==22">
                                <span v-html="item.questionName" style="font-weight: bold"></span>
                            </template>
                            <template v-else>
                                <span v-html="item.questionName"></span>
                            </template>

                        </p>
                        </template>
                        <p style="font-size: 10px;color:grey" v-html="item.questionDesc"></p>
                        <div>
                            <template v-if="item.questionType==2">
                                <el-select v-model="item.answer"  placeholder="请选择" @change="formSubmit(item)" :disabled="editIs==0||item.readonly">
                                    <el-option
                                            v-for="opt in JSON.parse(item.questionOption)"
                                            :key="opt.code"
                                            :label="opt.name"
                                            :value="opt.code" :disabled="editIs==0||item.readonly" >
                                    </el-option>
                                </el-select>
                            </template>
                            <template v-else-if="item.questionType==3">
                                <el-upload
                                        class="upload-demo"
                                        :action="uploadFile"
                                        :on-success="handleFileChange"
                                        :on-preview="handleFileView"
                                        :on-remove="handleFileRemove"
                                        :file-list="fileObjList" :disabled="editIs==0||item.readonly">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </template>
                            <template v-else-if="item.questionType==4">
                                <el-row :gutter="20">
                                    <el-col :sm="10" :xs="24">
                                        <el-select v-model="item.answer"
                                                   filterable
                                                   remote
                                                   clearable
                                                   reserve-keyword
                                                   :remote-method="querySearch"
                                                   @change="formSubmit(item)"
                                                   placeholder="请输入同事姓名或邮箱" :disabled="editIs==0||item.readonly">
                                            <el-option
                                                    v-for="user in selectUserList"
                                                    :key="user.USER_ID"
                                                    :label="user.USER_NAME"
                                                    :value="user.USER_ID">
                                            </el-option>
                                        </el-select>
                                    </el-col>
<!--                                    <el-col :sm="12" :xs="20">-->
<!--                                        <el-input-->
<!--                                                type="textarea"-->
<!--                                                :rows="2"-->
<!--                                                autosize-->
<!--                                                placeholder="你想要感谢的是什么"-->
<!--                                                @blur="formSubmit(item)"-->
<!--                                                v-model="item.answer" :disabled="editIs==0||item.readonly" maxlength="5000" show-word-limit>-->
<!--                                        </el-input>-->
<!--                                    </el-col>-->
                                </el-row>
                            </template>
                            <template v-else-if="item.questionType==5">
                                <el-row :gutter="20" v-for="(rel,relIndex) in item.relationEntityList" :key="relIndex" style="margin-bottom: 5px">
                                    <el-col :sm="10" :xs="24">
                                        <el-select v-model="rel.relationUserId"
                                                   filterable
                                                   remote
                                                   clearable
                                                   reserve-keyword
                                                   :remote-method="querySearch1"
                                                   @change="formSubmit(item)"
                                                   @focus="selectFocus(relIndex)"
                                                   ref="select"
                                                   placeholder="请输入同事姓名或邮箱" :disabled="editIs==0||item.readonly">
                                            <template v-if="currentSelectIndex==relIndex">
                                                <el-option
                                                        v-for="user in selectUserList1"
                                                        :key="user.USER_ID"
                                                        :label="user.USER_NAME"
                                                        :disabled="user.enable==0"
                                                        :value="user.USER_ID">
                                                </el-option>
                                            </template>
                                            <template v-else>
                                                <el-option
                                                        v-for="user in userAllList"
                                                        :key="user.USER_ID"
                                                        :label="user.USER_NAME"
                                                        :disabled="user.enable==0"
                                                        :value="user.USER_ID">
                                                </el-option>
                                            </template>

                                        </el-select>
                                    </el-col>
                                    <el-col :sm="12" :xs="20">
                                        <el-input
                                                type="textarea"
                                                :rows="2"
                                                autosize
                                                @paste.native.capture.prevent="handleFalse"
                                                @copy.native.capture.prevent="handleFalse"
                                                @cut.native.capture.prevent="handleFalse"
                                                @keyup.native="compute"
                                                placeholder="请用具体的事例表达感谢：“谢谢XX（人）在XX（场景下）具体做了XX（具体的事）使得XX（价值/帮助）"
                                                @blur="formSubmit(item)"
                                                v-model="rel.content" :disabled="editIs==0||item.readonly" minlength="15" maxlength="5000" show-word-limit>
                                        </el-input>
                                    </el-col>
                                    <el-col :sm="2" :xs="4">
                                        <el-button v-if="relIndex==0" :disabled="editIs==0||item.readonly" type="success" icon="el-icon-plus" circle size="small" @click="addQues(item)"></el-button>
                                        <el-button v-else type="danger" :disabled="editIs==0||item.readonly" icon="el-icon-minus" circle size="small" @click="minuQues(item,rel,relIndex)"></el-button>
                                    </el-col>
                                </el-row>
                            </template>
                            <template v-else-if="item.questionType==6">
                                <el-button :disabled="(leaderIs!=0||editIs==0||item.readonly)&&(leaderIs!=1||isLeaderEdit==0)" type="success" size="small" @click="addQues(item)">添加周事周毕</el-button>
                                <el-button :disabled="(leaderIs!=0||editIs==0||item.readonly)&&(leaderIs!=1||isLeaderEdit==0)" type="success" size="small" @click="returnQues(item,2)">一键驳回</el-button>
                                <span style="color: red;">(*注意: 请逐条添加,拖拽行可以排序优先级，越靠前越优先)</span>
                                <div class="drag-container" style="margin-top: 10px">
                                    <table class="drag-container">
                                        <thead>
                                            <tr style="font-size: 12px">
                                                <th width="60" rowspan="2">优先级</th>
                                                <th rowspan="2">工作内容<span><b style="color: red">*</b></span></th>
                                                <th rowspan="2" width="180" >服务对象<el-tooltip class="item" effect="dark" content="选择当前工作内容服务的对象，工作被确认完成后，自动导入用户访谈" placement="top-start">
                                                    <p class="el-icon-question"></p>
                                                </el-tooltip>
                                                    </th>
                                                <th rowspan="2" width="85">完成时间</th>
                                                <th rowspan="2" >添加人</th>
                                                <th rowspan="2" width="55">工时(小时)<span><b style="color: red">*</b></span></th>
<!--                                                <th width="70">提出异议</th>-->
                                               <th width="70" colspan="3">团队成员</th>
                                               <th width="70" colspan="2">leader</th>
                                               <th width="70" rowspan="2">操作</th>
                                            </tr>
                                            <tr style="font-size: 12px">
                                                <th >提出异议</th>
                                                <th >确认工作</th>
                                                <th >员工备注</th>
                                                <th >确认工作</th>
                                                <th >leader备注</th>
                                            </tr>
                                        </thead>
                                        <draggable v-model="item.relationEntityList" tag="tbody" @change="changeListSort(item)">
                                            <tr v-for="(rel,relIndex) in item.relationEntityList">
                                                <td>
                                                    <el-tag v-if="relIndex+1<=item.relationEntityList.length/3" type="danger" size="mini">{{relIndex+1}}</el-tag>
                                                    <el-tag v-if="relIndex+1>item.relationEntityList.length/3&&relIndex+1<=item.relationEntityList.length*2/3" type="warning" size="mini">{{relIndex+1}}</el-tag>
                                                    <el-tag v-if="relIndex+1>item.relationEntityList.length*2/3" type="success" size="mini">{{relIndex+1}}</el-tag>
                                                </td>
                                                <td style="padding: 12px 6px;">
                                                    <el-input
                                                            type="textarea"
                                                            :rows="2"
                                                            autosize
                                                            placeholder="这周要做的事"
                                                            @blur="formSubmit(item)"
                                                            v-model="rel.content"  maxlength="140">
                                                        <!--:disabled="!(leaderIs==rel.isLeader&&((leaderIs==0&&editIs==1&&!item.readOnly)||(leaderIs==1&&isLeaderEdit==1)))"-->
                                                    </el-input>
                                                </td>
                                                <td>
                                                    <el-select v-model="rel.relationUserId"
                                                               filterable
                                                               remote
                                                               clearable
                                                               reserve-keyword
                                                               :remote-method="querySearch"
                                                               @change="formSubmit(item)"
                                                               placeholder="请输入同事姓名或邮箱" :disabled="editIs==0||item.readonly">
                                                        <el-option
                                                                v-for="user in selectUserList"
                                                                :key="user.USER_ID"
                                                                :label="user.USER_NAME"
                                                                :value="user.USER_ID">
                                                        </el-option>
                                                    </el-select>
                                                </td>
                                                <td style="padding: 12px 6px;">
                                                    <el-select v-model="rel.weekName"
                                                               clearable
                                                               size="mini"
                                                               @change="formSubmit(item)"
                                                               placeholder="" :disabled="!(leaderIs==rel.isLeader&&((leaderIs==0&&editIs==1&&!item.readOnly)||(leaderIs==1&&isLeaderEdit==1)))">
                                                        <el-option
                                                                v-for="week in weekSelectList"
                                                                :key="week.value"
                                                                :label="week.text"
                                                                :value="week.value">
                                                        </el-option>
                                                    </el-select>
                                                </td>
                                                <td>
                                                    <el-tag v-if="rel.isLeader==1" type="success" size="mini">Leader</el-tag>
                                                    <el-tag v-if="rel.isLeader==0" type="primary" size="mini">Self</el-tag>
                                                </td>
                                                <td>
                                                    <el-input v-model="rel.workHours" placeholder="" @input="workHoursBlur(item,rel,relIndex,0)" @blur="workHoursBlur(item,rel,relIndex,1)"></el-input>
                                                </td>
                                                <td>
                                                    <el-checkbox v-model="rel.isDissent" :disabled="leaderIs!=0 || rel.isLeader!=1 || editIs == 0" :true-label="1" :false-label="0" size="medium" @change="formSubmit(item)"></el-checkbox>
                                                </td>
                                                <td>
                                                    <el-checkbox v-model="rel.isConfirmWorkEmploye" :disabled="leaderIs != 0 || editIs == 0"  :true-label="1" :false-label="0" size="medium" @change="formSubmit(item)"></el-checkbox>
                                                </td>
                                                <td>
                                                    <el-input
                                                            type="textarea"
                                                            :rows="2"
                                                            autosize
                                                            placeholder="员工确认工作备注"
                                                            @blur="formSubmit(item)"
                                                            v-model="rel.confirmWorkEmployeRemark" :disabled="leaderIs != 0 || editIs == 0" maxlength="5000" >
                                                    </el-input>
                                                </td>
                                                <td>
                                                    <el-checkbox v-model="rel.isConfirmWorkLeader" :disabled="leaderIs != 1 || isLeaderEdit == 0" :true-label="1" :false-label="0" size="medium" @change="formSubmit(item)"></el-checkbox>
                                                </td>
                                                <td>
                                                    <el-input
                                                            type="textarea"
                                                            :rows="2"
                                                            autosize
                                                            placeholder="领导确认工作备注"
                                                            @blur="formSubmit(item)"
                                                            v-model="rel.confirmWorkLeaderRemark" :disabled="leaderIs != 1 || isLeaderEdit == 0 " maxlength="5000" >
                                                    </el-input>
                                                </td>
                                                <td>
                                                    <el-button :disabled="!(leaderIs==rel.isLeader&&((leaderIs==0&&editIs==1&&!item.readOnly)||(leaderIs==1&&isLeaderEdit==1)))" type="danger" size="small" @click="minuQues(item,rel,relIndex)" icon="el-icon-delete" circle></el-button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>总计</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{{item.sumWorkHours}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </draggable>
                                    </table>
                                </div>
                            </template>
                            <template v-else-if="item.questionType==7">
                                <el-table :data="JSON.parse(item.answer.toString())" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                                    <el-table-column label="上月价值创造目标" prop="lastMonthValue"></el-table-column>
                                    <el-table-column label="上月实际价值创造计算" prop="lastMonthFactValue"></el-table-column>
                                    <el-table-column label="下个月价值创造目标" prop="nextMonthValue"></el-table-column>
                                </el-table>
                            </template>
                            <template v-else-if="item.questionType==8">
<!--                            +
-->
                                <span v-html="item.answer" style="font-size: 14px;padding-left:20px;color: grey;"></span>
                            </template>
                            <template v-else-if="item.questionType==9">
                                <el-checkbox @change="formSubmit(item)"
                                             v-model="tab.check"
                                             style="margin-bottom: 10px;margin-left: 0px!important;"
                                             size="mini" v-for="tab in item.answer"
                                             :label="tab.name"
                                             :true-label="1"
                                             :false-label="0"
                                             :key="tab.code"
                                             :disabled="editIs==0||item.readonly"
                                             border></el-checkbox>
                            </template>
                            <template v-else-if="item.questionType==10">
                                <template v-for="(supItem,supIndex) in item.subPaperAnswerEditVos">
                                    <div style="margin-left: 20px">
                                        <p>
                                            <span>{{supIndex+1}}) .</span>
                                            <span v-html="supItem.questionName"></span>
                                        </p>
                                        <template v-if="supItem.questionType==9">
                                            <el-checkbox
                                                    v-model="tab.check"
                                                    :true-label="1"
                                                    :false-label="0"
                                                    @change="formSubmit(item)"
                                                    style="margin-bottom: 10px;margin-left: 0px!important;"
                                                    size="mini"
                                                    v-for="tab in supItem.answer"
                                                    :key="tab.code"
                                                    :disabled="editIs==0||item.readonly"
                                                    :label="tab.name" border></el-checkbox>
                                        </template>
                                        <template v-else-if="supItem.questionType==12">
                                            <el-input-number v-model="supItem.answer" @change="formSubmit(item)" :min="supItem.questionNumberMin" :max="supItem.questionNumberMax" label="请输入内容" :disabled="editIs==0||item.readonly"></el-input-number>
                                        </template>
                                        <template v-else>
                                            <el-input
                                                    type="textarea"
                                                    :rows="2"
                                                    autosize
                                                    placeholder="请输入内容"
                                                    @blur="formSubmit(item)"
                                                    v-model="supItem.answer" :disabled="editIs==0||item.readonly" maxlength="5000" show-word-limit>
                                            </el-input>
                                        </template>
                                    </div>
                                </template>
                            </template>
                            <template v-else-if="item.questionType==11">
                                <el-select v-model="item.answer"
                                           filterable
                                           remote
                                           clearable
                                           reserve-keyword
                                           :remote-method="querySearch"
                                           @change="formSubmit(item)"
                                           placeholder="请输入同事姓名或邮箱" :disabled="editIs==0||item.readonly">
                                    <el-option
                                            v-for="user in selectUserList"
                                            :key="user.USER_ID"
                                            :label="user.USER_NAME"
                                            :value="user.USER_ID">
                                    </el-option>
                                </el-select>
                            </template>
                            <template v-else-if="item.questionType==14">
                                <el-table :data="item.dayReportVos" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0"><!--JSON.parse(item.answer.toString()) -->
                                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                                    <el-table-column label="周次" prop="dateWeek" width="90"></el-table-column>
                                    <el-table-column label="今日完成"  size="40%">
                                        <template slot-scope="scope">
<!--                                            <p v-html="scope.row.todayAnswer" style="text-align: left"></p>-->
                                            <el-input
                                                    type="textarea"
                                                    :rows="1"
                                                    autosize
                                                    :placeholder="item.textDefault"
                                                    @blur="formSubmit(item)"
                                                    v-model="scope.row.todayAnswer" :disabled="editIs==0||item.readonly||scope.row.kpiEnable==1" maxlength="5000" show-word-limit>
                                            </el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="明日必完成"  size="40%">
                                        <template slot-scope="scope">
<!--                                            <p v-html="scope.row.tomorrowAnswer" style="text-align: left"></p>-->
                                            <el-input
                                                    type="textarea"
                                                    :rows="1"
                                                    autosize
                                                    :placeholder="scope.row.kpiEnable==1?'':'无需填写'"
                                                    @blur="formSubmit(item)"
                                                    v-model="scope.row.tomorrowAnswer" :disabled="true" maxlength="5000" show-word-limit>
                                            </el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="来源" width="60">
                                        <template slot-scope="scope">
                                            <p v-html="scope.row.kpiEnable==1?'钉钉':'补写'" style="text-align: left"></p>

                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                            <template v-else-if="item.questionType==15">

                                <div class="drag-container" style="margin-top: 10px">

                                    <table class="drag-container" border>
                                        <thead>
                                        <tr style="font-size: 12px">
                                            <th width="5%" rowspan="2">优先级</th>
                                            <th rowspan="2" width="41%">工作内容</th>
                                            <th rowspan="2" width="8%">完成时间</th>
                                            <th width="60" rowspan="8%">添加人</th>
                                            <th width="60" rowspan="8%">总工时<span style="color:red">{{item.sumWorkHours}}</span>小时</th>
                                            <th width="15%" colspan="2">团队成员</th>
                                            <th width="15%" colspan="2">团队Leader</th>
                                        </tr>
                                        <tr style="font-size: 12px">
                                            <!-- <th width="70">提出异议</th> -->
                                            <th width="5%">确认</th>
                                            <th width="10%">备注</th>
                                           <!--  <th width="70">提出异议</th>-->
                                            <th width="5%">确认</th>
                                            <th width="10%">备注</th>
                                        </tr>
                                        </thead>
                                        <draggable v-model="item.relationEntityListTwo" tag="tbody" draggable="false"><!--@change="changeListSort"-->
                                            <tr v-for="(rel,relIndex) in item.relationEntityListTwo">
                                                <td>
                                                    <el-tag v-if="relIndex+1<=item.relationEntityListTwo.length/3" type="danger" size="mini">{{relIndex+1}}</el-tag>
                                                    <el-tag v-if="relIndex+1>item.relationEntityListTwo.length/3&&relIndex+1<=item.relationEntityListTwo.length*2/3" type="warning" size="mini">{{relIndex+1}}</el-tag>
                                                    <el-tag v-if="relIndex+1>item.relationEntityListTwo.length*2/3" type="success" size="mini">{{relIndex+1}}</el-tag>
                                                </td>
                                                <td style="padding: 12px 6px;">
                                                    <span v-html="rel.content" style="font-size: 14px;padding:20px"></span>
<!--                                                    <el-input-->
<!--                                                            type="textarea"-->
<!--                                                            :rows="2"-->
<!--                                                            autosize-->
<!--                                                            placeholder="这周要做的事"-->
<!--                                                            @blur="formSubmit(item)"-->
<!--                                                            v-model="rel.content" disabled maxlength="5000" show-word-limit>-->
<!--                                                    </el-input>-->
                                                </td>
                                                <td style="padding: 12px 6px;">
                                                    <span v-html="rel.weekName" style="font-size: 14px;padding:20px"></span>
<!--                                                    <el-select v-model="rel.weekName"-->
<!--                                                               clearable-->
<!--                                                               size="mini"-->
<!--                                                               @change="formSubmit(item)"-->
<!--                                                               placeholder="选周" disabled>-->
<!--                                                        <el-option-->
<!--                                                                v-for="week in weekSelectList"-->
<!--                                                                :key="week.value"-->
<!--                                                                :label="week.text"-->
<!--                                                                :value="week.value">-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
                                                </td>
                                                <td>
                                                    <el-tag v-if="rel.isLeader==1" type="success" size="mini">Leader</el-tag>
                                                    <el-tag v-if="rel.isLeader==0" type="primary" size="mini">Self</el-tag>
                                                </td>
                                                <td>
                                                    <span v-html="rel.workHours" style="font-size: 14px;padding:20px"></span>
<!--                                                   <el-input v-model="rel.workHours"  disabled placeholder="工时(小时)"></el-input>-->
                                                </td>
                                               <!-- <td>
                                                    <el-checkbox v-model="rel.isDissent" :disabled="leaderIs != 0 || rel.id == null || editIs == 0" :true-label="1" :false-label="0" size="medium" @change="submitIsDissent(rel)"></el-checkbox>
                                                </td>-->
                                                <td>
                                                    <el-checkbox v-model="rel.isFinishEmploye" :disabled="leaderIs != 0 ||rel.id == null || editIs == 0" :true-label="1" :false-label="0" size="medium" @change="submitWeekCheck(rel,0,1,1,item.relationEntityListTwo)"></el-checkbox>
                                                </td>
                                                <td>
                                                    <span v-html="rel.employRemark" style="font-size: 14px;padding:20px"></span>
<!--                                                    <el-input-->
<!--                                                            type="textarea"-->
<!--                                                            :rows="2"-->
<!--                                                            autosize-->
<!--                                                            placeholder="员工备注"-->
<!--                                                            @blur="submitRemarkInfo(rel)"-->
<!--                                                            v-model="rel.employRemark" :disabled="leaderIs != 0 || rel.id == null || editIs == 0" maxlength="5000">-->
<!--                                                    </el-input>-->
                                                </td>
                                               <!-- <td>
                                                    <el-checkbox v-model="rel.isDissentLeader" :disabled="leaderIs != 1 || isLeaderEdit == 0" :true-label="   1" :false-label="0" size="medium" @change="submitIsDissent(rel)"></el-checkbox>
                                                </td>-->
                                                <td>
                                                    <el-checkbox v-model="rel.isFinishLeader" :disabled="leaderIs != 1 || isLeaderEdit == 0" :true-label="1" :false-label="0" size="medium" @change="submitWeekCheck(rel,1,1,1,item.relationEntityListTwo)"></el-checkbox>
                                                </td>
                                                <td>
                                                    <span v-html="rel.leaderRemark" style="font-size: 14px;padding:20px"></span>
<!--                                                    <el-input-->
<!--                                                            type="textarea"-->
<!--                                                            :rows="2"-->
<!--                                                            autosize-->
<!--                                                            placeholder="领导备注"-->
<!--                                                            @blur="submitRemarkInfo(rel)"-->
<!--                                                            v-model="rel.leaderRemark" :disabled="leaderIs != 1 || isLeaderEdit == 0" maxlength="5000" >-->
<!--                                                    </el-input>-->
                                                </td>
                                            </tr>
<!--                                            <tr>-->
<!--                                                <td>总计</td>-->
<!--                                                <td></td>-->
<!--                                                <td></td>-->
<!--                                                <td></td>-->
<!--                                                <td>{{item.sumWorkHours}}</td>-->
<!--                                                <td></td>-->
<!--                                                <td></td>-->
<!--                                                <td></td>-->
<!--                                                <td></td>-->
<!--&lt;!&ndash;                                                <td></td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <td></td>&ndash;&gt;-->
<!--                                            </tr>-->
                                        </draggable>

                                    </table>
<!--                                    <el-button :disabled="(leaderIs!=0||editIs==0||item.readonly)&&(leaderIs!=1||isLeaderEdit==0)" style="float:right;padding: 10px" type="success" size="small" @click="returnQues(item,1)">通知员工</el-button>-->
                                    <el-checkbox @change="handleReportStatus1(item.relationEntityListTwo,allChecked)" style="float:right;padding: 10px" v-model="allChecked" :disabled="leaderIs!=1||isLeaderEdit==0">Leader确认以上均已完成</el-checkbox>
                                    <el-checkbox @change="handleReportStatus(item.relationEntityListTwo,unChecked)" style="float:right;padding: 10px" v-model="unChecked" :disabled="leaderIs!=1||isLeaderEdit==0">Leader确认以上均未完成</el-checkbox>

                                </div>

                            </template>
                            <template v-else-if="item.questionType==17">
                                <el-row :gutter="20" v-for="(rel,relIndex) in item.relationEntityList" :key="relIndex" style="margin-bottom: 5px" >
                                    <el-col :sm="12">
                                        <el-input
                                                placeholder="请输入业务指标"
                                                @blur="formSubmit(item)"
                                                v-model="rel.answerContent" :disabled="editIs==0||item.readonly">
                                            <template slot="prepend">业务指标:</template>
                                        </el-input>
                                    </el-col>
                                    <el-col :sm="12">
                                        <el-input
                                                placeholder="请输入实际达成"
                                                @blur="formSubmit(item)"
                                                v-model="rel.answerContent1" :disabled="editIs==0||item.readonly" >
                                            <template slot="prepend">实际达成:</template>

                                        </el-input>
                                    </el-col>
                                </el-row>
                            </template>
                            <template v-else-if="item.questionType==16">
                                <el-date-picker
                                        v-model="item.answer"
                                        type="date"
                                        @change="formSubmit(item)"
                                        :disabled="editIs==0||item.readonly"
                                        placeholder="选择日期">
                                </el-date-picker>

                            </template>
                            <template v-else-if="item.questionType==19">
                                <el-table :data="item" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0"><!--JSON.parse(item.answer.toString()) -->
                                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                                    <el-table-column label="当周任务"  size="40%">
                                        <template slot-scope="scope">
<!--                                            <p v-html="scope.row.answer" style="text-align: left"></p>-->
                                            <el-input
                                                    type="textarea"
                                                    :rows="1"
                                                    autosize
                                                    :placeholder="item.textDefault"
                                                    v-model="scope.row.answer" disabled maxlength="5000" show-word-limit>
                                            </el-input>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                            <template v-else-if="item.questionType==22">

                            </template>

                            <template v-else-if="item.questionType==21">
                                <el-table :data="item.relationEntityListTwo" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0"><!--JSON.parse(item.answer.toString()) -->
                                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                                    <el-table-column label="协作人" prop="dateWeek" width="120">
                                        <template slot-scope="scope">
                                            <p v-html="scope.row.relationUserName"></p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="工作内容"  >
                                        <template slot-scope="scope">
                                            <p v-html="scope.row.content" style="text-align: left"></p>

                                        </template>
                                    </el-table-column>
                                    <el-table-column label="所用工时"  size="120">
                                        <template slot-scope="scope">
                                            <p v-html="scope.row.workHours" ></p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="点赞" width="180">
                                        <template slot-scope="scope">
                                            <el-rate
                                                    v-model="scope.row.finished"
                                                    :disabled="editIs==0||item.readonly"
                                                    @change="saveAnswerRelation(scope.row)"
                                            >
                                            </el-rate>
                                        </template>
                                    </el-table-column>
                                </el-table>



                            </template>
                            <template v-else>
                                <el-input
                                        type="textarea"
                                        :rows="2"
                                        autosize
                                        :placeholder="item.textDefault"
                                        @blur="formSubmit(item)"
                                        v-model="item.answer" :disabled="editIs==0||item.readonly" maxlength="5000" show-word-limit>
                                </el-input>
                            </template>

                        </div>
                    </div>
                </template>

                <div style="text-align: center">
                    <el-button v-if="editIs==1" type="danger" @click="formSubmit('')" :disabled="editIs==0">保存</el-button>
                    <template v-else >
                        <el-button v-if="classId==9" type="danger" @click="formSubmit('')" :disabled="leaderIs!=1||isLeaderEdit==0">保存</el-button>

                        <template v-if="classId==8&&leaderIs==1">
                            <el-button type="primary" :disabled="reportFinish==0" @click="showDialogLeader=true">leader评价</el-button>
                        </template>
                        <el-button v-if="classId==1||classId==2||classId==2" :disabled="reportFinish==0||voitIs==0" type="primary" @click="showCommentDialog(1)">点赞</el-button>
                        <el-button v-if="classId==1||classId==2" type="danger" :disabled="reportFinish==0" @click="showCommentDialog(2)">评论</el-button>
                        <el-button v-if="classId==1||classId==2" type="success" :disabled="reportFinish==0" @click="savePaperRead(paperId)">已阅</el-button>
                    </template>
                </div>

        <el-dialog
                :title="dialogType==2?'评论原因':'点赞原因'"
                :visible.sync="showDialog"
                width="50%"
                :append-to-body=true
                center
                @close="closeLikeDialog">
            <el-input
                    type="textarea"
                    :rows="2"
                    autosize
                    placeholder="请输入内容"
                    v-model="likeCommitContent" maxlength="5000" show-word-limit>
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="likeCommitContent.length<=0" @click="cooperativeLike(paperId,periodId)">确 定</el-button>
              </span>
        </el-dialog>
        <el-dialog
                :title="'Leader评价'"
                :visible.sync="showDialogLeader"
                :append-to-body=true
                width="50%"
                center>
            <el-row>
            <template>
                <el-radio v-model="reportStatus" :label="1" @change="handleMonthReportStatus(reportStatus)">复盘有深度</el-radio>
                <el-radio v-model="reportStatus" :label="3" @change="handleMonthReportStatus(reportStatus)">复盘深度不足</el-radio>
            </template>
            </el-row>
            <el-row style="padding-top: 10px">
                <el-checkbox v-model="isNice" :true-label="1" :false-label="0" :disabled="reportStatus!=1" >推荐优秀复盘</el-checkbox>
            </el-row>


<!--            <el-checkbox v-model="isNice" :true-label="1" :false-label="0">是否推荐优秀复盘</el-checkbox>-->
<!--            <template>-->
<!--                <el-radio v-model="isNice" :label="1">推荐优秀复盘</el-radio>-->
<!--                <el-radio v-model="isNice" :label="2">复盘深度不足</el-radio>-->
<!--            </template>-->

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitLeaderComment(paperId,periodId)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList,uploadCooperativeFile,downloadExcelCooperative,saveAnswerRelation} from '@/api/api';
    import {getRouterPageHash} from '@/api/http';
    //import draggable from 'vuedraggable'
    import draggable from 'vuedraggable'


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                quesList:[],
                weekValue:new Date(),
                weekText:'',
                classId:0,
                recordsTotal:0,
                drawerShow:false,
                editIs:0,
                voitIs:0,
                leaderIs:0,
                periodId:'',
                paperId:'',
                fileObjList:[],
                uploadFile:uploadCooperativeFile,
                userAllList:[],
                selectUserList1:[],
                selectUserList:[],
                currentSelectIndex:-1,
                showDialog:false,
                dialogType:1,
                likeCommitContent:'',
                showDialogLeader:false,
                reportStatus:0,
                reportFinish:0,
                isNice:0,
                userId:'',
                title:'内容(*必填)',
                isLeaderEdit:0,
                isDissentEdit:0,
                weekSelectList:[
                    {text:'周一',value:'1'},
                    {text:'周二',value:'2'},
                    {text:'周三',value:'3'},
                    {text:'周四',value:'4'},
                    {text:'周五',value:'5'},
                    {text:'周六',value:'6'},
                    {text:'周日',value:'7'},
                ],
                allChecked:false,
                unChecked:false,
                paperpage:this.param,

            }
        },
        props:['sectionClassId','param'],
        computed:{

        },
        components:{
            draggable
        },
        //挂载时候执行
        mounted() {
            this.getCooperativeQues(this.paperpage)
            console.log(this.paperpage);
            //this.formInline.classId = this.sectionClassId
            //this.getCooperativeList()
//            this.getCooperativeAllUserList()
            //if(this.formInline.classId==8){
            //    this.selectMonth(new Date())
            //}else{
            //    this.selectWeek(new Date())
            //}


        },
        watch: {
            param(val){
                this.paperpage=val;

                this.getCooperativeQues(this.paperpage)
            }
        },
        methods: {
            //定义查询方法
            // getCooperativeList() {
            //     this.$store.dispatch('initCooperativeList',this.formInline).then(res=>{
            //         this.dataList = res.list
            //         this.recordsTotal = res.total
            //     })
            // },
            getCooperativeQues(obj) {
                this.getCooperativeAllUserList();
                this.drawerShow = true;
                this.voitIs = obj.isVoit;
                this.leaderIs = obj.isLeader==2?1:obj.isLeader;
                this.periodId = obj.periodId;
                this.paperId = obj.id;
                this.userId = obj.userId;
                this.editIs = obj.isEdit;
                this.classId=obj.questionClassId;
                this.reportStatus= obj.reportStatus;
                // this.allChecked=this.reportStatus==2?true:false;
                // this.unChecked=this.reportStatus==3?true:false;
                this.isNice = obj.isNice;
                console.log("isnice:"+this.isNice,obj)
                this.isLeaderEdit = obj.isLeaderEdit;
                this.isDissentEdit = obj.isDissentEdit;
                this.reportFinish = obj.status;//0未填写 1已填写
                this.title=obj.questionClassName+" (标*必填)"+" :【"+obj.userName+"】"+obj.periodName;
                this.$store.dispatch('initCooperativeQues',{classId:this.classId,paperId:obj.id}).then(res=>{
                    this.quesList = res
                  console.log('rr',res)
                    let arr = []
                    this.quesList.map((item,index)=>{


                      //以下内容为个人信息填入(李群)
                      if(obj.userId=='3039238394131487336'){//zhangchang
                        if(item.questionType==5){
                          console.log(5,item)
                          item.relationEntityList[0].content = '感谢茜姐日常帮助，以及在私域sop运营过程中的建议，非常感谢'
                          item.relationEntityList[0].relationUserId= "3058760457046793623"
                          item.relationEntityList[0].relationUserName= "石筱茜"
                        }
                        if(item.questionType==2){
                          item.answer = '5'
                        }
                        if(item.questionName=="6、「本周复盘」评估结果 & 分析原因&改进方式"||item.questionName=="2. 「本月复盘」下个月的改进\n"||item.questionName=="3. 下个月要交付的关键结果"||item.questionName=="1. 「本月复盘」评估结果 & 分析原因"||item.questionName=='7、「本周复盘」与Leader充分沟通'){
                          item.answer = '私域报表维护、SOP维护、SCRM规划开发、新奶卡开发'
                        }
                        if(item.questionName=="8、「下周规划」下周需要CLOSE的工作规划"||item.questionName=="5、「下周规划」下周需要CLOSE的工作规划"){
                          // item.answer = 'kbone小程序：优化及兼容；Vue：架构；react：后台管理；'
                          item.relationEntityList = [{
                            answerId: null,
                            content: '私域报表维护、SOP维护、SCRM规划开发',
                            createTime: null,
                            id: null,
                            relationUserId: '3039238394131487336',
                            relationUserName: null,
                            workHours:50,
                            isConfirmWorkEmploye:1,
                            isLeader:this.leaderIs
                          }]
                        }
                      }
                      //以下内容为个人信息填入(王汉晓)
                      if(obj.userId=='3081774071860501911'){//zhangchang
                        if(item.questionType==5){
                          console.log(5,item)
                          item.relationEntityList[0].content = '感谢后台同学后台配置测试商品，非常感谢'
                          item.relationEntityList[0].relationUserId= "3209902926803207115"
                          item.relationEntityList[0].relationUserName= "江飞飞"
                        }
                        if(item.questionType==2){
                          item.answer = '5'
                        }
                        if(item.questionName=="6、「本周复盘」评估结果 & 分析原因&改进方式"||item.questionName=="2. 「本月复盘」下个月的改进\n"||item.questionName=="3. 下个月要交付的关键结果"||item.questionName=="1. 「本月复盘」评估结果 & 分析原因"||item.questionName=='7、「本周复盘」与Leader充分沟通'){
                          item.answer = 'kbone小程序：优化及兼容；Vue：架构；react：后台管理；'
                        }
                        if(item.questionName=="8、「下周规划」下周需要CLOSE的工作规划"||item.questionName=="5、「下周规划」下周需要CLOSE的工作规划"){
                          // item.answer = 'kbone小程序：优化及兼容；Vue：架构；react：后台管理；'
                          item.relationEntityList = [{
                            answerId: null,
                            content: '小程序页面原生化',
                            createTime: null,
                            id: null,
                            relationUserId: '3039238394131487336',
                            relationUserName: null,
                            workHours:50,
                            isConfirmWorkEmploye:1,
                            isLeader:this.leaderIs
                          }]
                        }
                      }
                      //以下内容为个人信息填入(张畅)
                      if(obj.userId=='3080502748625350159'){//zhangchang
                        if(item.questionType==5){
                          console.log(5,item)
                          item.relationEntityList[0].content = '感谢后台同学后台配置测试商品，非常感谢'
                          item.relationEntityList[0].relationUserId= "3209902926803207115"
                          item.relationEntityList[0].relationUserName= "江飞飞"
                        }
                        if(item.questionType==2){
                          item.answer = '5'
                        }
                        if(item.questionName=="6、「本周复盘」评估结果 & 分析原因&改进方式"||item.questionName=="2. 「本月复盘」下个月的改进\n"||item.questionName=="3. 下个月要交付的关键结果"||item.questionName=="1. 「本月复盘」评估结果 & 分析原因"||item.questionName=='7、「本周复盘」与Leader充分沟通'){
                          item.answer = 'kbone小程序：优化及兼容；Vue：架构；react：后台管理；'
                        }
                        if(item.questionName=="8、「下周规划」下周需要CLOSE的工作规划"||item.questionName=="5、「下周规划」下周需要CLOSE的工作规划"){
                          // item.answer = 'kbone小程序：优化及兼容；Vue：架构；react：后台管理；'
                          item.relationEntityList = [{
                            answerId: null,
                            content: '小程序页面原生化',
                            createTime: null,
                            id: null,
                            relationUserId: '3039238394131487336',
                            relationUserName: null,
                            workHours:50,
                            isConfirmWorkEmploye:1,
                            isLeader:this.leaderIs
                          }]
                        }
                      }
                      //以下内容为个人信息填入(刘宏佳)
                      if(obj.userId=='3082133806849985211'){//zhangchang
                        if(item.questionType==5){
                          console.log(5,item)
                          item.relationEntityList[0].content = '感谢后台同学后台配置测试商品，非常感谢'
                          item.relationEntityList[0].relationUserId= "3209902926803207115"
                          item.relationEntityList[0].relationUserName= "江飞飞"
                        }
                        if(item.questionType==2){
                          item.answer = '5'
                        }
                        if(item.questionName=="6、「本周复盘」评估结果 & 分析原因&改进方式"||item.questionName=="2. 「本月复盘」下个月的改进\n"||item.questionName=="3. 下个月要交付的关键结果"||item.questionName=="1. 「本月复盘」评估结果 & 分析原因"||item.questionName=='7、「本周复盘」与Leader充分沟通'){
                          item.answer = 'kbone小程序：优化及兼容；Vue：架构；react：后台管理；'
                        }
                        if(item.questionName=="8、「下周规划」下周需要CLOSE的工作规划"||item.questionName=="5、「下周规划」下周需要CLOSE的工作规划"){
                          // item.answer = 'kbone小程序：优化及兼容；Vue：架构；react：后台管理；'
                          item.relationEntityList = [{
                            answerId: null,
                            content: '小程序页面原生化',
                            createTime: null,
                            id: null,
                            relationUserId: '3039238394131487336',
                            relationUserName: null,
                            workHours:50,
                            isConfirmWorkEmploye:1,
                            isLeader:this.leaderIs
                          }]
                        }
                      }



                        //正常代码
                        if(item.questionType==3){
                            arr = JSON.parse(item.answer||'[]')
                        }
                        if(item.questionType==9){
                            item.answer = JSON.parse(item.answer.toString())
                        }
                        if(item.questionType==10){
                            item.subPaperAnswerEditVos.map(item1=>{
                                if(item1.questionType==9){
                                    item1.answer = JSON.parse(item1.answer.toString())
                                }
                            })

                        }
                        if(item.questionType==15){
                            console.log(item.relationEntityListTwo);
                            //this.allChecked=item.relationEntityListTwo[0].finished==2?true:false;
                            //this.unChecked=item.relationEntityListTwo[0].finished==3?true:false;

                        }
                    })
                    this.fileObjList = arr.map(item=>{
                        return {name:item.name,url:item.url}
                    })
                })
            },
            getCooperativeAllUserList() {
                this.$store.dispatch('initCooperativeAllUserList',{type:0,classId:''}).then(res=>{
                    this.userAllList = res
                    this.selectUserList1 = res
                    this.selectUserList = res
                })
            },
            cooperativeLike(id,pId) {
                this.$store.dispatch('cooperativeLikeOrCancle',{periodId:pId,paperId:id,commit:this.likeCommitContent,voteType:this.dialogType}).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                    this.showDialog=false
                    this.dialogType=1
                    this.drawerShow=false
                    this.likeCommitContent = ''
                })
            },
            handleSizeChange(val) {
                //this.formInline.pageSize = val;
                //this.getCooperativeList()
            },
            handleCurrentChange(val) {
                //this.formInline.currentPage = val;
                //this.getCooperativeList()
            },
            // handleClose(done) {
            //     this.quesList=[]
            //     this.voitIs = 0;
            //     this.editIs = 0;
            //     this.periodId = '';
            //     this.paperId = '';
            //     this.userId = '';
            //     this.fileObjList = [];
            //     this.leaderIs = 0;
            //     this.reportStatus= 0;
            //     this.isNice = 0;
            //     this.reportFinish = 0;
            //     this.allChecked=false;
            //     this.unChecked=false;
            //     //this.getCooperativeList()
            //     done();
            // },
            formSubmit(obj){
                let _this = this;
                let subData = []
                let temRelation = [];

                if(obj){
                    if(obj.questionType==5){
                        temRelation = obj.relationEntityList.filter(item=>{
                            return (item.relationUserId!=null&&item.relationUserId!='')&&(item.content!=null&&item.content!='')
                        })
                    }
                    if(obj.questionType==6||(obj.questionType==13&&this.leaderIs==1)){
                        temRelation = obj.relationEntityList.filter(item=>{
                            return item.content!=null&&item.content!=''
                        })
                    }
                    if(obj.questionType==13&&this.leaderIs==0||obj.questionType==15||obj.questionType==17){
                        temRelation = obj.relationEntityList
                    }
                    if(obj.questionType==10){
                        temRelation = obj.subPaperAnswerEditVos
                    }
                    if(obj.questionType==14){
                        temRelation=obj.dayReportVos;
                    }
                    obj.answer = obj.questionType==3?JSON.stringify(_this.fileObjList):(obj.questionType==5||obj.questionType==6||obj.questionType==10||obj.questionType==13||obj.questionType==15||obj.questionType==17||obj.questionType==14?temRelation:(obj.answer||''))
                    subData = [obj]
                }else{
                    subData = this.quesList.map(item=>{
                        if(item.questionType==5){
                            temRelation = item.relationEntityList.filter(item1=>{
                                return (item1.relationUserId!=null&&item1.relationUserId!='')&&(item1.content!=null&&item1.content!='')
                            })
                        }
                        if(item.questionType==6||(item.questionType==13&&this.leaderIs==1)){
                            temRelation = item.relationEntityList.filter(item1=>{
                                return item1.content!=null&&item1.content!=''
                            })
                        }
                        if(item.questionType==13&&this.leaderIs==0||item.questionType==15||item.questionType==17){
                            temRelation = item.relationEntityList
                        }
                        if(item.questionType==10){
                            temRelation = item.subPaperAnswerEditVos
                        }
                        if(item.questionType==14){
                            temRelation=item.dayReportVos;
                        }
                        let newItem = {
                            paperId:item.paperId||'',
                            questionId:item.questionId||'',
                            questionType:item.questionType,
                            answer:item.questionType==3?JSON.stringify(_this.fileObjList):(item.questionType==5||item.questionType==6||item.questionType==10||item.questionType==13||item.questionType==15||item.questionType==17||item.questionType==14?temRelation:(item.answer||''))
                        }
                        return newItem
                    })
                }
                var re=false;
                for(var sub of subData){
                    //console.log("感谢");
                    console.log(sub);

                    if(sub.questionType==5){
                        var hash = {};
                        for(var ans of sub.answer){
                            if(ans.content.length<15){
                                this.$notify({
                                    title: '保存失败',
                                    message: '感谢内容必须多于15个字',
                                    type: 'error'
                                });
                                re=true;
                                console.log(re);
                                break;
                            }
                            if(hash[ans.content]) {
                                this.$notify({
                                    title: '保存失败',
                                    message: '感谢内容不能重复',
                                    type: 'error'
                                });
                                re=true;
                                console.log(re);
                                break;
                            }
                            // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
                            hash[ans.content] = true;
                        }
                    }
                    if(sub.questionType==6){
                        console.log(sub)
                        for(var ans of sub.answer){
                            if(ans.workHours==null||ans.workHours==''){
                                this.$notify({
                                    title: '保存失败',
                                    message: '下周周事周毕的工时必填',
                                    type: 'error'
                                });
                                re=true;
                                break;
                            }

                        }
                    }
                    if(re){
                        break;
                    }
                }
                console.log(re);
                if(re){
                    return subData;
                }
                console.log(subData)
                this.$store.dispatch('submitCooperativeQues',{answerEntityList:JSON.stringify(subData)}).then(res=>{
                    if(!obj){
                        //this.drawerShow = false;
                        this.$emit('drawClose','false')
                        //this.$emit('update:drawerShow',false)
                        //this.getCooperativeList();
                        this.$notify({
                            title: '成功',
                            message: '保存成功',
                            type: 'success'
                        });
                    }

                })
            },
            handleFileChange(file,fileList){
                console.log(file)
                this.fileObjList = this.fileObjList.concat(file.value)
            },
            handleFileView(file){
                window.open(file.url)
            },
            handleFileRemove(file,fileList){
                this.fileObjList = fileList
            },
            querySearchFun(queryString) {
                var restaurants = this.userAllList;
                return queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            },
            querySearch(queryString) {
                this.selectUserList =this.querySearchFun(queryString);
            },
            querySearch1(queryString) {
                this.selectUserList1 = this.querySearchFun(queryString);
            },
            selectFocus(index){
                this.currentSelectIndex = index
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.USER_NAME.indexOf(queryString) >-1);
                }
            },
            addQues(item){
                let _this = this
                item.relationEntityList.push({
                    answerId: null,
                    content: null,
                    createTime: null,
                    id: null,
                    relationUserId: null,
                    relationUserName: null,
                    isLeader:_this.leaderIs
                })
            },
            returnQues(item,type){
                this.$store.dispatch('returnQues',{paperId:this.paperId,type:type}).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: "消息发送成功",
                        type: 'success'
                    });
                })
                //console.log(this.paperId);
            },
            minuQues(item,rel,index){
                item.relationEntityList.splice(index,1);
                this.formSubmit(item)
                this.workHoursBlur(item,rel,index,0)
            },
            closeLikeDialog(){
                this.likeCommitContent = ''
            },
            // selectWeek(val){
            //     this.$store.dispatch('cooperativeWeekInfo',{date:val}).then(res=>{
            //         this.formInline.year = res.headYear
            //         this.formInline.period = res.headPeriod
            //
            //     })
            // },
            // selectMonth(val){
            //     this.formInline.year = val.getFullYear()
            //     this.formInline.period = val.getMonth()+1
            // },
            showCommentDialog(type){
                this.dialogType = type
                this.showDialog = true
            },
            submitLeaderComment(id,pId){
                this.$store.dispatch('saveModityPaperStatusInfo',{id:id,reportStatus:this.reportStatus,isNice:this.isNice}).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                    this.showDialogLeader=false
                    this.reportStatus=0
                    this.isNice=0
                })
            },
            submitWeekCheck(item,isLeader,checked,tanceng,relTwo){

                if(isLeader==1&&relTwo.length>0){

                    var val=0;
                    for (var r of relTwo) {
                        if(r.isFinishLeader==1){
                            val++;
                        }
                    }
                    if(val==relTwo.length){
                        console.log("test:"+val+","+relTwo)
                        this.unChecked=false;
                        this.allChecked=true;
                    }else if(val==0){
                        console.log("test:"+val+","+relTwo)
                        this.unChecked=true;
                        this.allChecked=false;
                    }else{
                        console.log("test:"+val+","+relTwo)
                        this.unChecked=false;
                        this.allChecked=false;
                    }
                }
                this.$store.dispatch('savemodityWeekAfterWeek',{id:item.id,isFinishEmploye:item.isFinishEmploye,isFinishLeader:item.isFinishLeader,checked:isLeader==1}).then(res=> {
                    console.log(res)
                    if(tanceng==1){
                        this.$notify({
                            title: '成功',
                            message: res,
                            type: 'success'
                        });
                    }

                })
            },
            submitRemarkInfo(item){
                this.$store.dispatch('saveRemarkInfo',{id:item.id,leaderRemark:item.leaderRemark,employRemark:item.employRemark}).then(res=> {
                    if(tanceng==1){
                        this.$notify({
                            title: '成功',
                            message: res,
                            type: 'success'
                        });
                    }

                })
            },
            workHoursBlur(item,rel,relIndex,isSave){

                let sumWorkHours = 0;
                for(let i = 0; i<item.relationEntityList.length; i++){
                    sumWorkHours = (parseFloat(sumWorkHours)+parseFloat((item.relationEntityList[i].workHours==null||item.relationEntityList[i].workHours=='')?0:item.relationEntityList[i].workHours)).toFixed(2);
                }
                item.sumWorkHours=sumWorkHours;
                if(isSave==1){
                    this.formSubmit(item);
                }

            },
            submitIsDissent(rel){
                this.$store.dispatch('saveIsDissentInfo',{id:rel.id,isDissentLeader:rel.isDissentLeader,isDissent:rel.isDissent}).then(res=> {
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                })
            },
            changeListSort(item){
                this.formSubmit(item);
                this.$notify({
                    title: '成功',
                    message: 'success',
                    type: 'success'
                });
                // console.log(item.moved)
                // let element = item.moved.element;
                // this.$store.dispatch('modifyPaperAnswerRelationSortInfo',{answerRelationId:element.id,questionId:element.questionId,sort:item.moved.newIndex+1,classId:this.formInline.classId,paperId:this.paperId,userId:this.userId}).then(res=> {
                //     console.log(res)
                //     this.$notify({
                //         title: '成功',
                //         message: 'success',
                //         type: 'success'
                //     });
                // })
            },
            // downloadExcel(){
            //     let url = `${downloadExcelCooperative}?classId=${this.formInline.classId}&year=${this.formInline.year}&period=${this.formInline.period}&pageRouterUrl=${getRouterPageHash(window.location.hash)}`
            //     window.open(url)
            // },
            handleReportStatus(relTwo,value){//未完成
                if(value){
                    var i=1;
                    for (var r of relTwo) {
                        r.isFinishLeader=0;
                        this.submitWeekCheck(r,1,!value,i,relTwo);
                        i++;
                        console.log(r);
                    }
                }
                if(value){
                    this.allChecked=!value;
                    this.handleReportStatus1(relTwo,this.allChecked);
                }

            },
            handleReportStatus1(relTwo,value){//完成
                if(value){
                    var i=1;
                    for (var r of relTwo) {
                        r.isFinishLeader=1;
                        this.submitWeekCheck(r,1,value,i,relTwo);
                        i++;
                        console.log(r);
                    }
                }
                if(value){
                    this.unChecked=!value;
                    this.handleReportStatus(relTwo,this.unChecked);
                }
            },
            handleMonthReportStatus(val){
                if(val!=1){
                    this.isNice=0;
                }
            },
            savePaperRead(paperId){
                this.$store.dispatch('savePaperRead',{paperId:paperId}).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                    //this.showDialog=false
                    //this.dialogType=1
                    this.$emit('drawClose','false');

                })
            },
            //方法
            handleFalse() {
                //终止
                return false;
            },
            compute() {
                // to do something
            },
            saveAnswerRelation(obj){
                console.log(obj)
                this.$store.dispatch('saveAnswerRelation',obj).then(res=> {
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                    //this.showDialog=false
                    //this.dialogType=1
                    //this.$emit('drawClose','false');

                })
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__body{
        overflow-y: scroll;
    }

    .el-textarea__inner{
        min-height: 40px !important;
    }
    .cooperate-form {
        .el-input-number{
            width: 220px !important;
        }
        .el-select{
            width: 100%;
        }
    }
    .drag-container{
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        td,th{
            padding: 12px 0;
            border:1px solid #E6E6E6;

        }
        th{
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
    .el-drawer__header{
        /*color:#000000;*/
        margin-bottom:10px;
        font-size:20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/cooperative/cooperativePersonal.vue